module.exports = __webpack_public_path__ + "img/banner-news-center.25aea08c.png";